import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import Header from '@/components/Header'
import { updateMe, updateUser } from '@/services/api'

export default function Profile() {
  const { user, updateProfile } = useAuth()
  const navigate = useNavigate()
  const [form, setForm] = useState<{ email: string; companyName: string; password: string }>({ email: user?.email || '', companyName: user?.companyName || '', password: '' })
  const [saving, setSaving] = useState(false)
  

  if (!user) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white shadow rounded p-6">
          <div className="mb-4">未登录</div>
          <button className="px-3 py-2 border rounded" onClick={() => navigate('/')}>去登录</button>
        </div>
      </div>
    )
  }

  const save = async () => {
    if (!form.email || !form.companyName) return
    setSaving(true)
    try {
      const payload: any = { email: form.email, companyName: form.companyName }
      if (form.password) payload.password = form.password
      try {
        await updateMe(payload)
      } catch {
        await updateUser(user.id, payload as any)
      }
      updateProfile({ email: form.email, companyName: form.companyName })
      alert('已保存')
    } catch {
      alert('保存失败')
    } finally {
      setSaving(false)
    }
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Header title="个人信息" backTo="/dashboard" />
      <main className="max-w-xl mx-auto py-6 sm:px-6 lg:px-8">
        <div className="bg-white shadow rounded-lg p-6">
          <div className="space-y-4">
            <div>
              <div className="text-sm text-gray-600 mb-1">邮箱</div>
              <input className="border rounded px-3 py-2 w-full" value={form.email} onChange={e=>setForm({ ...form, email: e.target.value })} />
            </div>
            <div>
              <div className="text-sm text-gray-600 mb-1">公司/组织</div>
              <input className="border rounded px-3 py-2 w-full" value={form.companyName} onChange={e=>setForm({ ...form, companyName: e.target.value })} />
            </div>
            <div>
              <div className="text-sm text-gray-600 mb-1">新密码（可选）</div>
              <input type="password" className="border rounded px-3 py-2 w-full" value={form.password} onChange={e=>setForm({ ...form, password: e.target.value })} />
            </div>
            <div>
              <button disabled={saving} className="bg-wechat-green text-white px-4 py-2 rounded" onClick={save}>{saving ? '保存中...' : '保存'}</button>
            </div>
          </div>
        </div>
      </main>
    </div>
  )
}
